var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSubtract = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IPM/icon/subtract") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IPM/icon/subtract",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(-0, -0)",
    fill: "#7A8E96",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar",
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6,12 C21.6,6.6980664 17.3019336,2.4 12,2.4 C6.6980664,2.4 2.4,6.6980664 2.4,12 M0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Copy",
    transform: "translate(12, 18) rotate(-180) translate(-12, -18)translate(0, 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6,12 C21.6,6.6980664 17.3019336,2.4 12,2.4 C6.6980664,2.4 2.4,6.6980664 2.4,12 M0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8.75637311,16.6230504 L15.8425206,9.71632022 C16.2346532,9.33411623 16.2427019,8.70639241 15.8604979,8.31425983 C15.8545826,8.30819082 15.8485896,8.3021979 15.8425206,8.29628255 C15.4372151,7.90123915 14.7908999,7.90123915 14.3855944,8.29628255 L7.29944686,15.2030127 C6.90731429,15.5852167 6.89926558,16.2129405 7.28146958,16.6050731 C7.28738493,16.6111421 7.29337785,16.617135 7.29944686,16.6230504 C7.70475237,17.0180938 8.3510676,17.0180938 8.75637311,16.6230504 Z",
    id: "Combined-Shape",
    fill: "#7A8E96",
    fillRule: "nonzero",
    transform: "translate(11.571, 12.4597) rotate(-315) translate(-11.571, -12.4597)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSubtract);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-subtract.3e466ae1405631c279ee54abde36f45b.svg";